export default "<p>inactive-merchant works!</p>\n"